import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ALL_CARD_JSON_LINK } from '../config/app-settings.config'
declare global {
  interface Window {
    cardJson: any;
    submitFormMulticardingPreLogin(url, cardCategory, cardType);
  }
}
@Injectable({
  providedIn: 'root'
})

export class CatalogueService {

  constructor(private http: HttpClient) { }
  referralCode: any;
  referpartnerDcr: any;
  //cardData:any
  getAllCardsJSON() {   
    return window.cardJson ? window.cardJson : null;
  }
  getAllCardsJSONURL() {    
     return this.http.get(ALL_CARD_JSON_LINK);
  }  

  setRefferalCode(refererVal) {
    this.referralCode = sessionStorage.setItem('referralCode', refererVal);
  }
}
